import React from "react";
import UserId from "../userId";

const Header = ({ title }) => {
  return (
    <div className=" pt-3 flex items-center justify-between ">
      <p className="text-3xl font-bold">{title}</p>
      <UserId />
    </div>
  );
};

export default Header;
